import { Button, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPXPForLocation } from '../../offices/offices-selectors';
import { createLocation } from '../../offices/offices-actions';
import { getWriteTabsPermissions } from '../../../store/user/user-reducer';
import { formItemMap } from '@med-fe/ui';
import { pxpConfig } from '../configs/pxp-config';

function PXPDetails({ locId }) {
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useDispatch();
  const data = useSelector((state) => getPXPForLocation(state, locId));
  const isEditAllowed = useSelector(getWriteTabsPermissions).pxp;

  useEffect(() => {
    form.setFieldsValue({
      ...data,
    });
  }, [locId]);

  const onSubmit = (formData: any) => {
    const { ...formDataValues } = formData;
    const payload = {
      ...formDataValues,
      id: locId,
      status: data.status,
      locationName: data.locationName,
    };
    dispatch(createLocation(payload));
  };

  return (
    <Form
      form={form}
      layout='vertical'
      className='pxp-details-form'
      onFinish={(formData) => {
        onSubmit(formData);
        setIsDisabled(true);
      }}
      onValuesChange={() => setIsDisabled(false)}
    >
      {Object.entries(pxpConfig).map(([key, value]: any) => {
        const params = {
          key,
          label: value.label,
          name: key,
          rules: value.rules,
          data: value.data,
          ...(value.type === 'checkbox' && { valuePropName: 'checked' }),
        };

        return (
          <Form.Item
            {...params}
            tooltip={
              'By enabling this flag, this office will not be shown as a ‘Featured Office’ in PXP, but will still show as available for booking.'
            }
          >
            {formItemMap(value, !isEditAllowed)}
          </Form.Item>
        );
      })}

      <Form.Item>
        <Button type='primary' htmlType='submit' className={'btn-form-action'} disabled={!isEditAllowed || isDisabled}>
          SAVE
        </Button>
      </Form.Item>
    </Form>
  );
}

export default PXPDetails;
